import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix: default Leaflet marker icons are broken when bundled via webpack.
// We replace them with a custom SVG pin rendered in Unight's neon-green brand colour.
const neonPinSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="38" viewBox="0 0 28 38" fill="none">
  <path d="M14 0C6.3 0 0 6.3 0 14c0 10.5 14 24 14 24s14-13.5 14-24c0-7.7-6.3-14-14-14z"
    fill="#B5FF00" stroke="#050505" stroke-width="1.5"/>
  <circle cx="14" cy="14" r="5" fill="#050505"/>
</svg>`;

const neonIcon = L.divIcon({
  html: neonPinSvg,
  className: 'unight-map-pin',
  iconSize: [28, 38],
  iconAnchor: [14, 38],
  popupAnchor: [0, -34],
});

// When the selected city changes, smoothly fly the map to the new centre/zoom
const MapFocus = ({ center, zoom }) => {
  const map = useMap();
  useEffect(() => {
    map.flyTo(center, zoom, { duration: 1.2 });
  }, [center, zoom, map]);
  return null;
};

const VenueMap = ({ venues, center, zoom = 12, cityKey }) => {
  return (
    <div
      className="bg-zinc-900 border border-zinc-800 h-[400px] relative overflow-hidden"
      data-testid="venue-map"
    >
      <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%', background: '#050505' }}
        key={cityKey}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        <MapFocus center={center} zoom={zoom} />
        {venues.map((venue) => (
          <Marker
            key={venue.name}
            position={[venue.coords.lat, venue.coords.lng]}
            icon={neonIcon}
          >
            <Popup>
              <div style={{ minWidth: 180 }}>
                <strong style={{ color: '#050505', fontFamily: 'Josefin Sans, sans-serif', fontSize: 16 }}>
                  {venue.name}
                </strong>
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#444' }}>
                  {venue.address}
                </p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default VenueMap;
